import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import imgLogo from "../assets/logos/logo_holistique.avif";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        {/* LOGO */}
        <div className="logo">
          <img src={imgLogo} alt="Logo Holistique" />
        </div>

        {/* NAV LINKS */}
        <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
          <NavLink to="/" end onClick={() => setMenuOpen(false)}>Inicio</NavLink>
          <NavLink to="/Productos" onClick={() => setMenuOpen(false)}>Productos</NavLink>
          <NavLink to="/Directorio-medico" onClick={() => setMenuOpen(false)}>Directorio Médico</NavLink>
          <NavLink to="/Blogs" onClick={() => setMenuOpen(false)}>Blog</NavLink>
          <NavLink to="/Sobre-nosotros" onClick={() => setMenuOpen(false)}>Sobre Nosotros</NavLink>
          <NavLink to="/Contacto" className="contacto-btn" onClick={() => setMenuOpen(false)}>Contacto</NavLink>
        </nav>

        {/* MENU RESPONSIVE */}
        <button aria-label="Menu" className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
            </svg>
          )}
        </button>
      </div>
    </header>
  );
}
